const ApiContentType = {
  FORM: 'form',
  JSON: 'json',
  IMAGE: 'image',
  PNG: 'image/png'
};
export { ApiContentType as default };
